import React, { FC, useContext } from 'react';
import { Redirect, Route, Switch as ReactRouterSwitch } from 'react-router';

import Settings from 'client/blocks/Settings/Settings';
import { SettingsPageContext } from 'client/context/settingsPageContext';
import { routes } from 'client/lib/routes';
import { InstallableApp } from 'client/model/skill';
import { getCanEditApp, getInstallableAppSettingsEntity } from 'client/utils';

import { FeatureFlags } from '../FeatureFlags/FeatureFlags';

interface Props {
    installableApp: InstallableApp;
    setInstallableApp: (app: InstallableApp) => void;
}

export const InstallableAppSettingsPage: FC<Props> = ({ installableApp, setInstallableApp }) => {
    const { hasUnsavedChanges, setHasUnsavedChanges } = useContext(SettingsPageContext);

    const disabled = !getCanEditApp(installableApp);

    return (
        <div>
            <article>
                <ReactRouterSwitch>
                    <Route
                        path={routes.app.installableAppSettings(
                            installableApp.channel,
                            false,
                            'feature-flags',
                            installableApp.id,
                        )}
                    >
                        <FeatureFlags />
                    </Route>

                    <Route
                        path={routes.app.installableAppSettings(
                            installableApp.channel,
                            true,
                            'feature-flags',
                            installableApp.id,
                        )}
                    >
                        <FeatureFlags />
                    </Route>

                    <Route
                        path={routes.app.installableAppSettings(
                            installableApp.channel,
                            true,
                            'main',
                            installableApp.id,
                        )}
                    >
                        <Settings
                            aliceApp={installableApp}
                            setInstallableApp={setInstallableApp}
                            isDraft={true}
                            registerChanges={setHasUnsavedChanges || ((_) => {})}
                            hasChanges={!!hasUnsavedChanges}
                            settings={getInstallableAppSettingsEntity(installableApp, true)}
                            disabled={disabled}
                        />
                    </Route>

                    <Route
                        path={routes.app.installableAppSettings(
                            installableApp.channel,
                            false,
                            'main',
                            installableApp.id,
                        )}
                    >
                        {installableApp.onAir ? (
                            <Settings
                                aliceApp={installableApp}
                                setInstallableApp={setInstallableApp}
                                isDraft={false}
                                registerChanges={setHasUnsavedChanges || ((_) => {})}
                                hasChanges={!!hasUnsavedChanges}
                                settings={getInstallableAppSettingsEntity(installableApp, false)}
                                disabled={disabled}
                            />
                        ) : (
                            <Redirect
                                to={routes.app.installableAppSettings(
                                    installableApp.channel,
                                    true,
                                    'main',
                                    installableApp.id,
                                )}
                            />
                        )}
                    </Route>

                    <Redirect
                        exact
                        from={routes.app.appPage(installableApp.channel, false, 'settings', installableApp.id)}
                        to={routes.app.installableAppSettings(installableApp.channel, false, 'main', installableApp.id)}
                    />

                    <Redirect
                        exact
                        from={routes.app.appPage(installableApp.channel, true, 'settings', installableApp.id)}
                        to={routes.app.installableAppSettings(installableApp.channel, true, 'main', installableApp.id)}
                    />
                </ReactRouterSwitch>
            </article>
        </div>
    );
};
